import Actions from '../../odata/actions';

const actions = new Actions('transactionModuleTask', 'transactionModuleTasks');

export default actions;
